import { getImage } from "../../../../utils/filesystem"
import Styles from '../../../../styles/Menu.module.css'
import Product from "./Product"
import { useInView } from "react-intersection-observer";
import { useCallback, useEffect } from "react";

export default function CategoryProducts(props) {
    const getProductImg = useCallback(async product => {
        return await getImage(props.menu.userid + '/' + product[0] + '/01.jpg')
    }, [props.menu])

    const [ref, inView] = useInView({
        threshold: 0.25
    });

    useEffect(() => {
        props.toggleActiveTab(inView)
    }, [inView, props.toggleActiveTab])

    return (
        <div ref={ref}>
            <span className={Styles.category}>{props.category}</span>

            <div className={Styles.productsContainer}>
                {props.products.map((product, index) => {
                    const offer = product[1].offer ? props.menu.offers[props.menu.offers.findIndex(offer => offer.id === product[1].offer)] : null

                    return (
                        <Product
                            key={index}
                            offer={offer && props.isActiveBySchedule(offer.schedule) ? offer : null}
                            product={product}
                            getProductImg={getProductImg}
                            addProductToOrder={props.addProductToOrder}
                            color={props.menu.color}
                            storeIsOpen={props.storeIsOpen}
                        />
                    )
                })}
            </div>
        </div>
    )
}